module.exports = __webpack_public_path__ + "img/ИФ-1(А)-015-m.7b7571bc.png";